import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { pushNotification } from "utils/notifications";
import ConfigPhiKhacApi from "service/QuanTriHeThong/CauHinhTinhLaiVaHeThong/ConfigPhiKhacApi";
import ConfigPhiKhacHangKyApi from "service/QuanTriHeThong/CauHinhTinhLaiVaHeThong/ConfigPhiKhacHangKyApi";

// Giả định CustomCheckbox được truyền vào qua props
export const ModalThemMoi = ({ show, onHide, item, onSaved, loanType, isPeriodic, CustomCheckbox }) => {
    const initData = { ConfigPhiKhacId: 0, TenPhiKhac: "", LoaiPhiKhac: 3, KieuPhiKhac: loanType };
    const [phiData, setPhiData] = useState(initData);
    const [isSubmit, setIsSubmit] = useState(false);
    const [error, setError] = useState("");

    const api = isPeriodic ? ConfigPhiKhacHangKyApi : ConfigPhiKhacApi;

    useEffect(() => {
        if (show) {
            if (item) {
                setPhiData({
                    ConfigPhiKhacId: item.ConfigPhiKhacId,
                    TenPhiKhac: item.TenPhiKhac || "",
                    LoaiPhiKhac: item.LoaiPhiKhac || 3,
                    KieuPhiKhac: item.KieuPhiKhac || loanType
                });
            } else {
                setPhiData(initData);
            }
            setError("");
        }
    }, [item, show, loanType]);

    // Chỉ xử lý cho input text
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setPhiData(prev => ({ ...prev, [name]: value }));

        if (name === 'TenPhiKhac' && value.trim() === "") setError("Tên phí không được để trống");
        else if (name === 'TenPhiKhac') setError("");
    };

    // Xử lý riêng cho CustomCheckbox
    const handleCheckboxChange = (e, checkboxValue) => {
        const { checked } = e.target;
        const currentLoaiPhiKhac = phiData.LoaiPhiKhac;
        let newLoaiPhiKhac;

        if (checked) {
            newLoaiPhiKhac = currentLoaiPhiKhac === 3 ? 3 : (currentLoaiPhiKhac + checkboxValue);
        } else {
            newLoaiPhiKhac = currentLoaiPhiKhac - checkboxValue;
        }
        
        // Logic đảm bảo luôn có ít nhất 1 checkbox được chọn
        if (newLoaiPhiKhac === 0) {
            newLoaiPhiKhac = checkboxValue === 1 ? 2 : 1;
        }
        
        setPhiData(prev => ({ ...prev, LoaiPhiKhac: newLoaiPhiKhac }));
    };


    const handleSave = async (e) => {
        e.preventDefault();
        if (!phiData.TenPhiKhac.trim()) {
            setError("Tên phí không được để trống");
            return;
        }

        setIsSubmit(true);
        try {
            const res = await api.addOrUpdate(phiData);
            if (res.status === 200) {
                pushNotification("Lưu thành công!", "success");
                onSaved();
            } else {
                pushNotification(res.data || "Lưu thất bại!", "error");
            }
        } catch (err) {
            pushNotification(err?.response?.data || "Lưu thất bại!", "error");
        } finally {
            setIsSubmit(false);
        }
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="modal-new modal fade text-left" 
        >
            <Modal.Header>
                <h4 className="modal-title color7-bold ml-1" id="myModalLabel16">
                    {phiData.id > 0 ? "Sửa phí khác" : "Thêm mới phí khác"}
                </h4>
                <button type="button" className="close-popup-new" onClick={onHide}> 
                    <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
                </button>
            </Modal.Header>
            <form onSubmit={handleSave}>
                <Modal.Body className=""> 
                    <div className="form form-horizontal"> 
                        <div className="form-body">
                            <div className="form-body"> 
                                <div className="form-group row">
                                    <label className="col-md-3 label-control color7-bold">Tên phí <span className="canh-bao-red">*</span></label>
                                    <div className="col-md-9">
                                        <input
                                            type="text"
                                            className="form-control input-sm"
                                            name="TenPhiKhac"
                                            value={phiData.TenPhiKhac}
                                            onChange={handleInputChange} // <-- Dùng handler cho text
                                            placeholder="Nhập tên phí"
                                        />
                                        <span className="canh-bao-red">{error}</span>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-3 label-control color7-bold">Kiểu nhập</label>
                                    <div className="col-md-9">
                                        {/* Thay thế bằng CustomCheckbox */}
                                        <CustomCheckbox
                                            id="nhapTien"
                                            name="LoaiPhiKhac"
                                            label="Nhập tiền"
                                            checked={phiData.LoaiPhiKhac === 1 || phiData.LoaiPhiKhac === 3}
                                            onChange={(e) => handleCheckboxChange(e, 1)} // <-- Dùng handler mới
                                            className="form-check-inline" // Thêm class để thử cho inline
                                        />
                                        <CustomCheckbox
                                            id="nhapPhanTram"
                                            name="LoaiPhiKhac"
                                            label="Nhập %"
                                            checked={phiData.LoaiPhiKhac === 2 || phiData.LoaiPhiKhac === 3}
                                            onChange={(e) => handleCheckboxChange(e, 2)} // <-- Dùng handler mới
                                            className="form-check-inline" // Thêm class để thử cho inline
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer> {/* <-- Áp dụng cấu trúc footer từ modal thứ 2 */}
                    <button
                        type="button"
                        className="btn btn-new-main btn-closenew"
                        onClick={onHide}
                    >
                        <span>
                            <i className="mdi mdi-close"></i>
                        </span>
                        &nbsp; Đóng
                    </button>
                    <button type="submit" className="btn btn-new-main button-popup-submit" disabled={isSubmit}>
                        <span>
                            <img src="/app-assets/images/icon-send-v2.png" alt="save" />
                        </span>
                        &nbsp; {isSubmit ? "Đang lưu..." : (phiData.id > 0 ? "Lưu" : "Thêm mới")}
                    </button>
                </Modal.Footer>
            </form>
        </Modal>
    );
};